import type { QuoteData } from '@iqd/shared-quoting/core';
import { BudgetResult } from '../budget-result';

interface Step4ResultProps {
  quoteData: QuoteData;
  drawing: unknown;
  backsheet: unknown;
  onStartOver: () => void;
}

export function Step4Result({ quoteData, drawing, backsheet, onStartOver }: Step4ResultProps) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold text-hilevel-slate mb-1">Your budget</h2>
        <p className="text-sm text-hilevel-gray">
          Here's the price for your mezzanine. A copy is on its way to your email.
        </p>
      </div>
      <BudgetResult
        quoteData={quoteData}
        drawing={drawing}
        backsheet={backsheet}
        onStartOver={onStartOver}
      />
    </div>
  );
}
